/**
 * `useClickOutside` hook for capturing clicking outside of an element
 */

import * as React from "react"

type Props = {
  ref: React.RefObject<HTMLElement | undefined>
  onClickOutside: (event: MouseEvent) => void
}

const useClickOutside = ({ ref, onClickOutside }: Props) => {
  const handleClickOutside = React.useCallback(
    (event: MouseEvent) => {
      if (!ref.current) return
      if (ref.current?.contains(event.target as Node)) {
        // inside click
        return
      }
      // outside click
      event.preventDefault()
      onClickOutside(event)
    },
    [ref, onClickOutside]
  )

  React.useEffect(() => {
    const callback = handleClickOutside
    document.addEventListener("mousedown", callback)

    return () => {
      document.removeEventListener("mousedown", callback)
    }
  }, [handleClickOutside])
}

export default useClickOutside
